module.exports = __webpack_public_path__ + "static/media/TeamCultureGood.be108357.png";